<template>
    <div :style="{ marginTop: marginTop }">
      <b-row :style="{ backgroundColor: backgroundColor }">
        <b-col class="row-item">
  
          <h2><a :href="modelAssetURL">{{  title }}</a>   </h2>
          <div>{{ description }}</div>
          <div>{{ $utils.state.uploadStatus }}</div>
    
  
          <div v-if="$store.isDebug" >
                <div>{{ modelAssetURL }}</div>
                <div>{{ modelAssetURLiOS }}</div>
                <div>{{ shortCode }}</div>
          </div>
          
          <b-row>
  
            <b-col class="sub-row-item">
  
  
              <div v-if="imageSrc">
                <img :src="imageSrc" style="width: 300px; height: 300px; object-fit: cover;" alt="Preview" />
              </div>
              <model-viewer v-else ref="modelViewer"
                            alt="house" 
                            :src="modelAssetURL" 
                            :ios-src="modelAssetURLiOS"
                            ar 
                            ar-modes="scene-viewer quick-look"
                            shadow-intensity="1" 
                            camera-controls 
                            touch-action="pan-y"
                            :ar-scale="arScale"
                            style="width: 300px; height: 300px;">
              </model-viewer>
            </b-col>
  
            <b-col v-if="!isMobile" class="sub-row-item">
              <qr-code :text="qrCodeUrl" :size="qrCodeSize"></qr-code>
              <a v-if="$store.isDebug && $store.state.isAdmin" :href="`${qrCodeUrl}`">{{ qrCodeUrl }}</a>
            </b-col>
  
  
            <b-col  class="sub-row-item">
  
              <div>{{ modelInfo }}</div>
  
              <div v-if="addModelViewer">
              <b-button @click="gotoModelViewer" variant="primary">Model viewer</b-button>
              <p></p>
            </div>
  
              <b-button v-if="!isMobile && $store.state.isAdmin" v-bind="{tag: 'a', href: `${modelAssetURL}`, download:'model.glb'}" variant="primary">Download model</b-button>
              <p></p>
  
              <b-button v-if="$store.state.isAdmin" @click="convertToMaquette" variant="primary">Convert to maquette</b-button>
              <p></p>
  
              <b-button v-if="$store.state.isAdmin" @click="convertToUSDZ" variant="primary">Convert to USDZ</b-button>
              <p></p>
  
              <b-button @click="gotoQR" variant="primary">QR voor 3D model</b-button>
              <p></p>
  
              <p v-if="$store.state.isAdmin">
                <b-dropdown :text="currentProject || 'Selecteer een project...'" class="custom-dropdown" variant="primary">
                <b-dropdown-item 
                  v-for="(project, index) in this.$store.state.projects"
                  :key="index" 
                  @click="updateProject(shortCode, project.PartitionKey)">
                  {{ project.PartitionKey }}
                </b-dropdown-item>
              </b-dropdown>
              </p>
  
  
  
  
            </b-col>
  
          </b-row>  
        </b-col>
  
  
      </b-row>
    </div>
  </template>
  
  <script>

import VueQRCodeComponent from 'vue-qrcode-component'
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';


  export default {
    data: function () {
      return{
        isMobile: false,
        newShortCode: "",
        currentProject:"",
        modelInfo:""
      }
    },
    props: {
      title: {
        type: String,
        default: ""
      },
      description: {
        type: String,
        default: ""
      },
      modelSrc: {
        type: String,
        default: ""
      },
      iosSrc: {
        type: String,
        default: null
      },
      baseUrl: {
        type: String,
        default: ""
      },
      shortCode: {
        type: String,
        default: ""
      },
      project: {
        type: String,
        default: ""
      },
      backgroundColor: {
        type: String,
        default: ""
      },
      qrCodeSize: {
        type: Number,
        default: 800
      },
      addModelViewer: {
        type: Boolean,
        default: false
      },
      allowScale: {
        type: Boolean,
        default: null
      },
      imageSrc: {
        type: String,
        default: ""
      },
      marginTop: {
        type: String,
        default: "0px"
      },
      routePrefix: {
        type: String,
        default: "ar"
      }
      
    },
    mounted:function(){
      this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      this.currentProject = this.$props.project;
      if(!this.imageSrc) {
        this.getModelInfo();
      }
    },
    methods: {
      gotoModelViewer() {
        this.$router.push(`/modelviewer/${this.$props.shortCode}`);
      },
      gotoQR() {
        this.$router.push(`/qr/?url=${this.qrLink}`);
      },
      convertToMaquette(){
        console.log("modelrow converttomaquette");

        var scene = new THREE.Scene();
        const loader = new GLTFLoader();
        
        loader.load(this.modelAssetURL,(gltf) => {

          // Create a box around the GLB object
          const box = new THREE.Box3().setFromObject(gltf.scene);
          var boxSize = box.getSize(new THREE.Vector3()).length();
          var boxCenter = box.getCenter(new THREE.Vector3());

          // Create an invisible box mesh to surround the GLB object
          const geometry = new THREE.BoxGeometry(boxSize, boxSize, boxSize);
          const material = new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true, transparent: true, opacity: 0.1 });
          
          const invisibleBox = new THREE.Mesh(geometry, material);
          invisibleBox.name = "invisiblebox";
          invisibleBox.position.copy(boxCenter);

          // Add the GLB object as a child of the invisible box
          invisibleBox.add(gltf.scene);
          gltf.scene.position.set(-boxCenter.x, -boxCenter.y, -boxCenter.z);

          // Add the invisible box to the scene
          scene.add(invisibleBox);

          //now resize and upload  
          var sceneMaquette = new THREE.Scene();
          var group = new THREE.Group();

          scene.children.forEach((child) => {
                if (!child.isLight && !child.isCamera && child.name != "floor") {

                  if (child.name == "invisiblebox") 
                  {
                    let parentPosition = child.position.clone();
                    child = child.children[0];

                    const clonedChild = child.clone();
                    clonedChild.position.add(parentPosition);
                    group.add(clonedChild);

                  }
                  else{
                    const clonedChild = child.clone();
                    group.add(clonedChild);
                  }
                  
                }
            });

          var scale = 1/ boxSize;
          group.scale.set(scale, scale, scale);

          sceneMaquette.add(group);

          var splitted = this.modelFileName.split('.');
          var filename = `${splitted[0]}_maquette.${splitted[1]}`;

          this.$utils.uploadMaquette(sceneMaquette, filename);

        });
      },
      convertToUSDZ() {
        const loader = new GLTFLoader();
        loader.load(this.modelAssetURL,(gltf) => {

          var filename = this.modelFileName.replace(/\.glb$/i, '.usdz');
          this.$utils.uploadUSDZ(gltf.scene, filename);

        },
        undefined,
        (error) => {
          console.error('Er is een fout opgetreden bij het laden van het GLB-model:', error);
        }
      );
      },
      async getShortcode() {

        const isUrl  = this.isUrlValid(this.modelAssetURL);
        const assetUrl = isUrl ? this.modelAssetURL : `${window.location.origin}/${this.modelAssetURL}`;
               
        fetch(`${this.$store.apiUrl}/getshortcode`, {
                method: 'POST',
                body: JSON.stringify({ url: assetUrl}),
                headers: {
                    'Content-Type': 'application/json'
                }
                })
                .then(response => {
                    if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
                })
                .then(data => {
                  console.log(data);
                    this.newShortCode = data.shortCode;
                    this.currentProject = data.project;
                })
                .catch(error => {
                    console.error('Fetch Error:', error);
            });
      },
      updateProject(shortcode, project){
        if(this.currentProject != project){
        this.currentProject = project;
          //console.log(`${shortcode}/${project}`);
          this.$utils.AddProjectToShortUrl(shortcode, project);
        }
      },
      isUrlValid(url) {
          var pattern = /^(http|https):\/\//i;
          return pattern.test(url);
      },
      getModelInfo(){

        this.modelInfo = "Counting vertices...";

        const loader = new GLTFLoader();

        loader.load(this.modelAssetURL, (gltf) => {
          let totalVertices = 0;
          let totalFaces = 0;

            gltf.scene.traverse((child) => {
                if (child.isMesh) {
                    const geometry = child.geometry;

                    // Tel vertices op
                    totalVertices += geometry.attributes.position.count;

                    // Tel faces op
                    if (geometry.index) {
                        totalFaces += geometry.index.count / 3;
                    } else {
                        totalFaces += geometry.attributes.position.count / 3;
                    }
                }
            });
            this.modelInfo = `Totaal vertices, faces: ${totalVertices} / ${totalFaces}`;
        });
      }
    },
    computed: {
      qrLink() {
        var encodedUrl = encodeURIComponent(`${window.location.origin}/#/3d/${this.shortCode}`);
        return encodedUrl;
      },
      modelAssetURL() {
        if (!this.modelSrc) {
          return '';
        }

        if (this.modelSrc.startsWith('/')) {
          return this.modelSrc;
        }

        if(this.isUrlValid(this.modelSrc)){
          return this.modelSrc;
        }
        else{
          const normalizedBase = this.baseUrl ? this.baseUrl.replace(/\/$/, '') : '';
          const normalizedSrc = this.modelSrc.replace(/^\//, '');
          return `${normalizedBase}/${normalizedSrc}`;
        }
      },
      modelAssetURLiOS() {
        if (!this.iosSrc) {
          return '';
        }

        if (this.iosSrc.startsWith('/')) {
          return this.iosSrc;
        }

        if(this.isUrlValid(this.iosSrc)){
          return this.iosSrc;
        }
        else{
          const normalizedBase = this.baseUrl ? this.baseUrl.replace(/\/$/, '') : '';
          const normalizedSrc = this.iosSrc.replace(/^\//, '');
          return `${normalizedBase}/${normalizedSrc}`;
        }
      },
      modelViewerURL() {
        if(this.shortCode == "") this.getShortcode(); //TODO is tyhis still needed?
        else this.newShortCode = this.shortCode;
        return `${window.location.origin}/#/ar/${this.newShortCode}`;
      },
      modelFileName(){
        var splitted = this.modelAssetURL.split('/models/');
        var filename = splitted[1];
        return filename;
      },
      arScale() {
        if (this.$props.allowScale != null) {
          return this.$props.allowScale == true ? "auto" : "fixed";
        }
        return this.modelAssetURL.includes("_maquette") ? "auto" : "fixed";
},
      qrCodeUrl() {
        if(this.shortCode == "") this.getShortcode(); 
        else this.newShortCode = this.shortCode;
        return `${window.location.origin}/#/${this.routePrefix}/${this.newShortCode}`;
      }
  },
  watch: {
    project(newValue) {
      // Update currentProject wanneer de project prop verandert
      this.currentProject = newValue;
    },
    modelSrc(newValue, oldValue) {
      console.log(`myProp is gewijzigd van "${oldValue}" naar "${newValue}"`);
      this.getModelInfo();
    }
  },
    components: {
      'qr-code': VueQRCodeComponent
    }
  }
  </script>

<style scoped>

.row-item{
  font-size: 16px;
  padding: 40px;
  margin:auto;
}

.sub-row-item{
  margin-top: auto;
  margin-bottom: auto;
}

.custom-dropdown .dropdown-toggle {
  background-color: #F0F0F0 !important; /* Set the background color of the button */
  color: #0000FF !important; /* Set the text color of the button */
  border: 1px solid #0000FF !important; /* Optional: border color */
}

.custom-dropdown .dropdown-toggle:hover {
  background-color: #C0C0C0 !important; /* Set the background color on hover */
  color: #FFFFFF !important; /* Set the text color on hover */
}

.custom-dropdown .dropdown-menu {
  background-color: #F0F0F0 !important; /* Set the background color of the dropdown menu */
}

.custom-dropdown .dropdown-item {
  color: #0000FF !important; /* Set the text color of the items */
}

.custom-dropdown .dropdown-item:hover {
  background-color: #C0C0C0 !important; /* Set the background color on hover */
  color: #FFFFFF !important; /* Set the text color on hover */
}


</style>
